export default class TryingToUpdateBeforeReceivingError extends Error {
  id: string;

  constructor(id: any) {
    super(`Tried to update item with id ${id} before item is added to state`);
    this.id = id;
  }
}
